import React, {useState, useEffect, useContext, useRef} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {colorFunctions} from "../constants/colors";
import {COLOR_GRAY_BANNER_BACKGROUND} from "../constants/general-constants";

export default function ConditionCriticality({id, label, scoreLabel, score}){
	
	
	const refScoreColorsContainer = useRef(null);
	
	const [scoreLabelMarginLeft, setScoreLabelMarginLeft] = useState("0px");
	const [scoreArrowMarginLeft, setScoreArrowMarginLeft] = useState("0px");
	const [scoreWidth, setScoreWidth] = useState("0%");
	const [scoreColor, setScoreColor] = useState("white");
	
	const scoreColors = [
		{score:"4", color:"darkgreen"},
		{score:"3", color:"lightgreen"},
		{score:"2", color:"yellow"},
		{score:"1", color:"red"},
		{score:"0", color:"darkred"}
	];
	
	const LABEL_WIDTH = 100;
	
	useEffect(() => {
		let thisScoreWidth = Math.round(100/scoreColors.length);
		setScoreWidth(thisScoreWidth+ "%");
		thisScoreWidth = thisScoreWidth*(refScoreColorsContainer.current.getBoundingClientRect().width)/100;
		setScoreLabelMarginLeft(LABEL_WIDTH + parseInt(score)*thisScoreWidth);
		setScoreArrowMarginLeft(LABEL_WIDTH + parseInt(score)*thisScoreWidth + thisScoreWidth/2 - 7);
		setScoreColor(scoreColors[parseInt(score)].color);
	}, [id]);
	
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 40px)",
		marginLeft:"20px",
		marginTop:"20px",
		marginRight:"20px",
		flexDirection:"column"
	};
	
	const scoreLabelContainer = {
		display:"flex",
		marginLeft:scoreLabelMarginLeft + "px",
		height:"20px",
		color:"white",
		fontSize:"14px",
		width:"60px",
		backgroundColor:scoreColor,
		borderRadius:"5px",
		alignItems:"center",
		justifyContent:"space-around"
	};
	
	const remainingContent = {
		display:"flex",
		width:"100%",
		alignItems:"center"
	};
	
	const labelContainer = {
		display:"flex",
		width:LABEL_WIDTH + "px",
		color:"white",
		fontSize:"14px",
		fontWeight:"bold"
	};
	
	const scoreColorsContainer = {
		display:"flex",
		flexGrow:"1",
		height:"20px",
		//border:"1px solid darkgrey",
		borderRadius:"5px"
	};
	
	const scoreColorPanel = {
		display:"flex",
		width:scoreWidth,
		height:"100%"
	};
	
	const getBorderTopLeftRadius =(index) => {
		if(index === 0){
			return "5px";
		}
		else{
			return "0px";
		}
	};
	
	const getBorderBottomLeftRadius =(index) => {
		if(index === 0){
			return "5px";
		}
		else{
			return "0px";
		}
	};
	
	const getBorderTopRightRadius =(index) => {
		if(index === (scoreColors.length - 1)){
			return "5px";
		}
		else{
			return "0px";
		}
	};
	
	const getBorderBottomRightRadius =(index) => {
		if(index === (scoreColors.length - 1)){
			return "5px";
		}
		else{
			return "0px";
		}
	};
	
	const scoreDisplay = scoreColors.map((item, index) =>
		<div style={{...scoreColorPanel, borderTopLeftRadius:getBorderTopLeftRadius(index), borderBottomLeftRadius:getBorderBottomLeftRadius(index), borderTopRightRadius:getBorderTopRightRadius(index), borderBottomRightRadius:getBorderBottomRightRadius(index), backgroundColor:item.color}}/>
	);
	
	const scoreArrow = {
		display:"flex",
		color:"white",
		margin:"0px",
		width:"15px",
		height:"15px",
		marginLeft:scoreArrowMarginLeft + "px",
		marginBottom:"2px"
	};
	
	return (
		<div style={thisContainer}>
			<div style={scoreLabelContainer}>
				{scoreLabel}
			</div>
			<FontAwesomeIcon icon="arrow-down" style={scoreArrow}/>
			<div style={remainingContent}>
				<div style={labelContainer}>
					{label}:
				</div>
				<div style={scoreColorsContainer} ref = {refScoreColorsContainer}>
					{scoreDisplay}
				</div>
			</div>
		</div>
	);
}